<template>
  <div class="jr-full-editor" :id="id"></div>
</template>

<script>
import {mixin} from './index.js'
export default {
  name: 'full-editor',
  mixins: [mixin]
}
</script>

<style scoped lang="scss">
.jr-full-editor{
  width: 100%;
  height: 100%;
}
.jr-full-editor{
  > div{
    z-index: 10!important;
  }
}
.jr-full-editor div{
  z-index: 10!important;
}
</style>



// WEBPACK FOOTER //
// src/common/full-editor/index.vue